import CustomField from "components/common/CustomField";
import CustomLabel from "components/common/CustomLabel";
import CustomPhoneInput from "components/common/CustomPhoneInput";
import { Form, Formik } from "formik";
import { X } from "lucide-react";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addCustomer } from "store/actions/customerSlice";
import { showAlert } from "store/reducers/alertReducer";

const initialValues = {
  name: "",
  phoneCode: "+966",
  phoneNumber: "",
};

const AddCustomer = ({ setShow1, modalType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState(initialValues);

  const { loading, isLoading } = useSelector((state) => state.Customers);

  const handleSubmit = (values, { resetForm }) => {
    const { name, phoneCode, phoneNumber } = values || {};
    if (!phoneNumber)
      return dispatch(
        showAlert({
          text: "Please enter phone number",
          type: "error",
        })
      );

    if (modalType === "ADD") {
      dispatch(addCustomer(values))
        .then((action) => {
          const { statusCode, success, message } = action?.payload;
          if (statusCode === 200 && success) {
            dispatch(showAlert({ text: message, type: "success" }));
            setShow1(false);
            resetForm();
          } else {
            dispatch(showAlert({ text: message, type: "error" }));
          }
        })
        .catch((err) => {});
    }
  };
  return (
    <div>
      <div className="modal_header g_between">
        <h2 className="fs_17">
          {modalType === "ADD" ? t("Add Customer") : t("Edit Customer")}
        </h2>
        <X
          onClick={() => setShow1(false)}
          className="text_black c_p"
          width={20}
          height={20}
        />
      </div>
      <Formik
        initialValues={formValues}
        // validationSchema={addUserSchema(modalType)}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values, errors, touched }) => (
          <Form>
            <Row>
              <Col lg={12}>
                <div className="form_field mt_13">
                  <CustomLabel htmlFor="name" label={t("Name")} />
                  <CustomField
                    name="name"
                    type="text"
                    placeholder={t("Name")}
                    touched={touched}
                    errors={errors}
                  />
                </div>
                <div className="form_field mt_13">
                  <CustomLabel
                    htmlFor="phoneNumber"
                    label={t("Phone Number")}
                  />
                  <CustomPhoneInput
                    initialPhoneCode={values.phoneCode}
                    initialPhoneNumber={values.phoneNumber}
                    onChange={({ phoneNumber, countryCode }) => {
                      setFieldValue("phoneNumber", phoneNumber);
                      setFieldValue("phoneCode", countryCode);
                    }}
                  />
                </div>
              </Col>
              <Col lg={12}>
                <div className="g_between mt-4 gap-3">
                  <button
                    type="button"
                    className="cancel_btn w-50"
                    onClick={() => setShow1(false)}
                  >
                    {t("Cancel")}
                  </button>
                  <button
                    type="submit"
                    className="main_btn w-50"
                    disabled={isLoading}
                  >
                    {modalType === "ADD" ? t("Add") : t("Save")}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddCustomer;
